export const UploadPaths = Object.freeze({
  UNGROUPED: 'ungrouped',
})

export const SalesChannels = Object.freeze({
  ONLINE: 'Online',
  SPECIFIC_OUTLETS: 'Specific Outlets + online',
  ALL_OUTLETS: 'All Outlets + online',
})

export const PaymentMethod = Object.freeze({
  CreditCard: 'CreditCard',
  KeksPay: 'KeksPay',
  PayCek: 'PayCek',
})

export const OrganizationCustomTicketFee = Object.freeze({
  319: { 0.8: { min: 0, max: 19.99 }, 1.2: { min: 20, max: 39.99 }, 1.6: { min: 40, max: 10000 } },
  357: { 0.8: { min: 0, max: 19.99 }, 1.2: { min: 20, max: 39.99 }, 1.6: { min: 40, max: 10000 } },
  405: { 0.8: { min: 0, max: 19.99 }, 1.2: { min: 20, max: 39.99 }, 1.6: { min: 40, max: 10000 } },
})

export const Venue = Object.freeze({
  ARENA_ZAGREB: 'Arena Zagreb',
  LISINSKI_ZAGREB: 'Koncertna dvorana Vatroslav Lisinski',
})

export const CategoryType = Object.freeze({
  THEATER: 'Theater',
  MUSIC: 'Music',
  SPORT: 'Sport',
})

export const OrganizationSlug = Object.freeze({
  TVORNICA_KULTURE: 'tvornica-kulture-e2f8',
})
export const PromoCodeDiscountType = Object.freeze({
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
})
export const CoreEventFeeType = Object.freeze({
  TICKET: 'CoreEvent ticket fee',
})
export const OrganizationType = Object.freeze({
  REGULAR: 'REGULAR',
  THEATER: 'THEATER',
  SPORT_ORGANIZATION: 'SPORT_ORGANIZATION',
})
export const TicketType = Object.freeze({
  REGULAR: 'regular',
  TABLE: 'table',
  PARTER: 'parter',
})
export const TicketSellerOrganizationType = Object.freeze({
  REGULAR: 'REGULAR',
  THEATER: 'THEATER',
})
export const PerformanceBy = Object.freeze({
  EVENT: 'EVENT',
  PREFERENCES: 'PREFERENCES',
})
export const SeatState = Object.freeze({
  HOLD: 'hold',
  SOLD: 'sold',
  AVAILABLE: 'available',
  DISABLED: 'disabled',
})

export const SvgElementCEType = Object.freeze({
  PARTER: 'parter',
  REGULAR: 'regular',
  TABLE: 'table',
})
export const EventPerformanceType = Object.freeze({
  PREMIERE: 'PREMIERE',
  REPRISE: 'REPRISE',
  GUEST: 'GUEST',
  REGULAR_SCREENING: 'REGULAR_SCREENING',
  MATINEE: 'MATINEE',
  TALK: 'TALK',
})
export const InterestType = Object.freeze({
  GENRE: 'GENRE',
  TAG: 'TAG',
  PREFERENCE: 'PREFERENCE',
})
export const OrderStatusEnum = Object.freeze({
  PURCHASING: 'PURCHASING',
  FAILED: 'FAILED',
  SUCCESSFUL: 'SUCCESSFUL',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  REFUNDED: 'REFUNDED',
})
export const EventTypeImgSrc = Object.freeze({
  FLOOR_PLAN: '/assets/floorPlanEvent.svg',
  REGULAR: '/assets/regularEvent.svg',
})
export const ReportTypes = Object.freeze({
  DAILY: 'daily',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  CUSTOM: 'custom',
})
export const EventCategoryId = Object.freeze({
  MUSIC: 1,
  SPORT: 2,
  CONFERENCE: 3,
  OTHER: 4,
  THEATER: 5,
})

export const UserType = Object.freeze({
  TRIAL: 'TRIAL',
  TICKET_SELLER: 'TICKET_SELLER',
  SUPER_ADMIN: 'SUPER_ADMIN',
  TICKET_SELLER_ADMIN: 'TICKET_SELLER_ADMIN',
  EVENT_WORKER: 'EVENT_WORKER',
})

export const GoogleAuth = Object.freeze({
  CLIENT_ID: process.env.VUE_GOOGLE_CLIENT_ID,
  PLUGIN_NAME: 'CoreEvent',
})

export const ColorToggleTypes = Object.freeze({
  REGULAR: 'regular',
  SUCCESSFUL: 'successful',
  FAILED: 'failed',
  DISABLED: 'disabled',
})

export const TicketLinkingEnum = Object.freeze({
  LINKED: 'LINKED',
  UNLINKED: 'UNLINKED',
  NO_LINKING: 'NO_LINKING',
})

export const OrderItemType = Object.freeze({
  TICKET: 'ticket',
  ARTICLE: 'article',
  PREPAID_COUPON: 'prepaidCoupon',
  MEMBERSHIP_PLAN: 'membershipPlan',
})

export const DatePickerRangeType = Object.freeze({
  DATE: 'date',
  MONTH: 'month',
})

export const OrganizerSidebarRouteKeys = Object.freeze({
  PENDING_REQUESTS: 'requests',
  ACCREDITATION_BUILDER: 'builder-accreditation',
})

export const EventState = Object.freeze({
  DRAFT: {
    key: 'draft',
    label: 'DRAFT',
    color: '#666666',
    backgroundColor: '#F5F5F5',
  },
  SCHEDULED: {
    key: 'scheduled',
    label: 'SCHEDULED',
    color: '#666666',
    backgroundColor: '#F5F5F5',
  },
  PUBLISHED: {
    key: 'published',
    label: 'PUBLISHED',
    color: '#0277BD',
    backgroundColor: '#F5F5F5',
  },
  SALES_PAUSED: {
    key: 'salesPaused',
    label: 'SALES PAUSED',
    color: '#666666',
    backgroundColor: '#F5F5F5',
  },
  CANCELED: {
    key: 'canceled',
    label: 'CANCELED',
    color: '#BD2A3C',
    backgroundColor: '#FBEBED',
  },
  NO_MORE_TICKETS: {
    key: 'noMoreTickets',
    label: 'PUBLISHED',
    color: '#0277BD',
    backgroundColor: '#F5F5F5',
  },
  SOLD_OUT: {
    key: 'soldOut',
    label: 'SOLD OUT',
    color: '#55A35D',
    backgroundColor: '#EEF6EF',
  },
})

export const EventStatus = Object.freeze({
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHED: 'PUBLISHED',
  CANCELLED: 'CANCELLED',
})
